interface ImageSource {
  src: string;
  id?: string;
}

interface ImageType {
  avif?: ImageSource;
  webp?: ImageSource;
  fallback: ImageSource;
}

type BackgroundImgDetails =
  | { as_background: true; id?: string }
  | { as_background: false };

const PictureCmp = ({
  img_type,
  class_name,
  background_img_info = { as_background: false },
  alt,
}: {
  img_type?: ImageType;
  class_name?: string;
  background_img_info?: BackgroundImgDetails;
  alt?: string;
}) => {
  if (background_img_info.as_background) {
    return <div id={background_img_info.id} className={class_name} />;
  }

  return (
    <picture>
      {img_type?.avif ? (
        <source
          id={img_type.avif.id}
          srcSet={img_type.avif.src}
          type="image/avif"
        />
      ) : null}
      {img_type?.webp ? (
        <source
          id={img_type.webp.id}
          srcSet={img_type.webp.src}
          type="image/webp"
        />
      ) : null}
      <img
        id={img_type?.fallback.id}
        src={img_type?.fallback.src}
        className={class_name}
        alt={alt}
      />
    </picture>
  );
};

export default PictureCmp;
